/* eslint-disable import/no-anonymous-default-export */
import environment from '../environments/Environment';
import HttpService from './HttpService';
import HttpServiceNoToken from './HttpServiceNoToken';

export default {
    saveCCTV(payload) {
        return HttpService.put(environment.API_CCTV_POLICY, payload);
    },
    searchCCTV(params) {
        return HttpService.get(environment.API_CCTV_POLICY, {
            params,
        });
    },
    getCCTVDetail(policyId) {
        return HttpService.get(environment.API_CCTV_POLICY + `/${policyId}`);
    },
    getPublishedVersion(id) {
        return HttpService.get(
            environment.API_CCTV_POLICY + `/publish-version/` + id
        );
    },
    getNoSecurePublishedVersion(id) {
        return HttpService.get(
            environment.API_CCTV_POLICY_PUBLIC + `/publish-version/` + id
        );
    },
    getCCTVDetailPublic(policyId) {
        return HttpServiceNoToken.get(
            environment.API_CCTV_POLICY_PUBLIC + `/${policyId}`
        );
    },
    //History
    getHistoriesCCTV(params) {
        return HttpService.get(environment.API_CCTV_POLICY + `/history`, {
            params,
        });
    },
    getHistoryDetail(params) {
        return HttpService.get(
            environment.API_CCTV_POLICY + `/history/detail`,
            {
                params,
            }
        );
    },
    delete(policyId) {
        return HttpService.delete(environment.API_CCTV_POLICY + `/${policyId}`);
    },
    rename(payload) {
        return HttpService.put(
            environment.API_CCTV_POLICY + `/rename`,
            payload
        );
    },
};
